import { FeatureBlock, FeatureComparison } from "../_copy-template"
import Reviews from "~images/pages/comparison/features/reviews.png"

export function getReviewsCopy(competitor: FeatureBlock): FeatureComparison {
    return {
        name: "Reviews",
        image: Reviews,
        chckup: {
            showCheck: true,
            description:
                "With Chckvet, you can automatically view & collect private, Google, or Facebook reviews to boost your practice's reputation & visibility. You can also collect other feedback like surveys for your practice.",
        },
        competitor,
        href: "/features/reviews",
    }
}
